// extracted by mini-css-extract-plugin
export default {"box":"IndividualFilter_box__PvcMA","activeChip":"IndividualFilter_activeChip__SkxO6","chip":"IndividualFilter_chip__iHJw7"};